import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../../auth/require-session.js';
import { SessionError, SessionPending } from '../../../auth/SessionStates.js';
import { TableReadPage } from '../../../read/table-read-page.js';

/** `/read/:id/table` (1.W deliverable 5): the table-read, guarded as `/doc/:id` is. */
export const Route = createFileRoute('/read/$id/table')({
  staticData: { crumb: 'Table-read' },
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: TableReadRoute,
});

function TableReadRoute(): React.JSX.Element {
  const { id } = Route.useParams();
  return <TableReadPage key={id} docId={id} />;
}
